import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import { OktaRoutingModule } from './okta-routing.module';
import { oktaConfig } from './configuration/okta';

const oktaAuth = new OktaAuth(oktaConfig);
const moduleConfig: OktaConfig = { oktaAuth };

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    OktaRoutingModule,
    OktaAuthModule.forRoot(moduleConfig)
  ],
  exports: [
  ],
})
export class OktaModule { }
